import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import logo from '~/assets/images/logo-Einstein-Verifica.svg';

import {
  Container,
  CreateAccountBox,
  ImageContainer,
  CreateAccountContainer,
  InputContainer,
  Label,
  Input,
  Form,
  ButtonCreateAccount,
  Title,
  InputError,
  Header,
  DataInput,
  FirstInput,
  LastInput,
  Backto,
  ButtonContainer,
} from './styles';

const CreateAccount = () => {
  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      crf: '',
      newPassword: '',
      confirmPassword: '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Campo Obrigatório'),
      email: Yup.string().required('Campo Obrigatório'),
      crf: Yup.string().required('Campo Obrigatório'),
      newPassword: Yup.string()
        .matches(
          /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
          'Validar requerimentos mínimos'
        )
        .required('Campo Obrigatório'),

      confirmPassword: Yup.string()
        .required('Campo Obrigatório')
        .oneOf([Yup.ref('newPassword'), null], 'Esta senha não corresponde'),
    }),

    onSubmit: (values, { resetForm }) => {
      resetForm(formik.initialValues);
      return values;
    },
  });

  return (
    <Container>
      <CreateAccountBox>
        <Header>
          <ImageContainer>
            <img src={logo} alt="HIAE" />
          </ImageContainer>
        </Header>
        <CreateAccountContainer>
          <Title>Criação de conta</Title>
          <Form>
            <InputContainer>
              <Label>Nome Completo</Label>
              <Input
                {...formik.getFieldProps('name')}
                id="name"
                name="name"
                type="text"
                placeholder="Nome Completo"
                onChange={formik.handleChange}
                value={formik.values.name}
                error={!!(formik.touched.name && formik.errors.name)}
                helperText
              />
              <InputError>
                {formik.touched.name && formik.errors.name
                  ? formik.errors.name
                  : null}
              </InputError>
            </InputContainer>
            <DataInput>
              <FirstInput>
                <InputContainer>
                  <Label>CRF</Label>
                  <Input
                    {...formik.getFieldProps('crf')}
                    id="crf"
                    name="crf"
                    type="text"
                    placeholder="CRF"
                    onChange={formik.handleChange}
                    value={formik.values.crf}
                    error={!!(formik.touched.crf && formik.errors.crf)}
                    helperText
                  />
                  <InputError>
                    {formik.touched.crf && formik.errors.crf
                      ? formik.errors.crf
                      : null}
                  </InputError>
                </InputContainer>
                <InputContainer>
                  <Label>E-mail</Label>
                  <Input
                    {...formik.getFieldProps('email')}
                    id="email"
                    name="email"
                    type="text"
                    placeholder="E-mail"
                    onChange={formik.handleChange}
                    value={formik.values.email}
                    error={!!(formik.touched.email && formik.errors.email)}
                    helperText
                  />
                  <InputError>
                    {formik.touched.email && formik.errors.email
                      ? formik.errors.email
                      : null}
                  </InputError>
                </InputContainer>
              </FirstInput>
              <LastInput>
                <InputContainer>
                  <Label>Senha</Label>
                  <Input
                    {...formik.getFieldProps('newPassword')}
                    id="newPassword"
                    name="newPassword"
                    type="password"
                    placeholder="Senha"
                    onChange={formik.handleChange}
                    onKeyUp={() => {}}
                    value={formik.values.newPassword}
                    error={
                      !!(
                        formik.touched.newPassword && formik.errors.newPassword
                      )
                    }
                    helperText
                  />
                  <InputError>
                    {formik.touched.newPassword && formik.errors.newPassword
                      ? formik.errors.newPassword
                      : null}
                  </InputError>
                </InputContainer>
                <InputContainer>
                  <Label>Confirmar senha</Label>
                  <Input
                    {...formik.getFieldProps('confirmPassword')}
                    id="confirmPassword"
                    name="confirmPassword"
                    type="password"
                    placeholder="Confirmar senha"
                    onChange={formik.handleChange}
                    value={formik.values.confirmPassword}
                    error={
                      !!(
                        formik.touched.confirmPassword &&
                        formik.errors.confirmPassword
                      )
                    }
                    helperText={
                      formik.touched.confirmPassword &&
                      formik.errors.confirmPassword
                        ? formik.errors.confirmPassword
                        : null
                    }
                  />
                  <InputError>
                    {formik.touched.confirmPassword &&
                    formik.errors.confirmPassword
                      ? formik.errors.confirmPassword
                      : null}
                  </InputError>
                </InputContainer>
              </LastInput>
            </DataInput>
            <ButtonContainer>
              <ButtonCreateAccount type="submit" onClick={() => {}}>
                CRIAR CONTA
              </ButtonCreateAccount>
            </ButtonContainer>
            <Backto href="/receita/login">Voltar para o login</Backto>
          </Form>
        </CreateAccountContainer>
      </CreateAccountBox>
    </Container>
  );
};

export default CreateAccount;
